import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PostCrecaAccountsService } from "@/features/accounts/creca/services/post-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { usePostCrecaAccountStates } from "@/features/accounts/creca/hooks/use-post-accounts-states";
import { useContext } from "react";


export const usePostCrecaAccount = () => {
  const {
    crecaAccountId,
    setCrecaAccountId,
    crecas,
    setCrecas,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = usePostCrecaAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const postCrecaAccountsService = new PostCrecaAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // クレカ登録
  const registerCrecaAccounts = async (
    accountGroupId: string,
    crecaAccountId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await postCrecaAccountsService.postCrecaAccounts({
        account_group_id: accountGroupId,
        creca_account_id: crecaAccountId,
      });
      // 成功時の処理
      setCrecas(res);
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("registerCrecaAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    crecaAccountId,
    setCrecaAccountId,
    crecas,
    setCrecas,
    isShowErrorDialog,
    setIsShowErrorDialog,
    registerCrecaAccounts: errorHandledAsync(registerCrecaAccounts, setError),
  };
};
